import {ImportingDataTypes} from "../../types";
import {
    createInvalidPartSection,
    createInvalidTagSection,
    PreventionInvalidityCode,
    PreventativeAutocompleteType,
} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productTagAssignment,
    sections: [
        createInvalidPartSection("partNumber"),
        createInvalidTagSection("tagName"),
        {
            sectionKey: "missingProductTagFields",
            sectionTitle: "Missing Required Fields",
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: "partNumber",
                    label: "Part Number",
                    type: PreventativeAutocompleteType.PART,
                    extractValue: (o) => (typeof o === "string" ? o : o?.partNo ?? null),
                    modifyRow: (row, val) => ({...row, partNumber: val}),
                    autocompleteProps: {
                        placeholder: "Search for part...",
                        getOptionLabel: (o) => o?.partNo ?? "",
                        isOptionEqualToValue: (o, v) => o?.partNo === v?.partNo,
                    },
                },
                {
                    key: "tagName",
                    label: "Tag Name",
                    type: PreventativeAutocompleteType.TAG,
                    extractValue: (o) => (typeof o === "string" ? o : o?.name ?? null),
                    modifyRow: (row, val) => ({
                        ...row,
                        tagName: typeof val === "string" ? val : val?.name ?? val,
                    }),
                    autocompletePropsFromContext: (staticDataContext) => ({
                        industryId: staticDataContext?.industryId,
                        freeSolo: false,
                        getOptionLabel: (o) => (typeof o === "string" ? o : o?.name ?? ""),
                        isOptionEqualToValue: (o, v) =>
                            typeof o === "string" || typeof v === "string"
                                ? o === v
                                : o?.id === v?.id,
                    }),
                },
            ],
        },
    ],
};
